"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var files_1 = require("./files");
var items_1 = require("./items");
var Folders = (function (_super) {
    __extends(Folders, _super);
    function Folders(baseUrl, path) {
        if (path === void 0) { path = "folders"; }
        _super.call(this, baseUrl, path);
    }
    Folders.prototype.getByName = function (name) {
        var f = new Folder(this);
        f.concat("('" + name + "')");
        return f;
    };
    Folders.prototype.add = function (url) {
        var _this = this;
        return new Folders(this, "add('" + url + "')").post().then(function (response) {
            return {
                data: response,
                folder: _this.getByName(url),
            };
        });
    };
    return Folders;
}(queryable_1.QueryableCollection));
exports.Folders = Folders;
var Folder = (function (_super) {
    __extends(Folder, _super);
    function Folder(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(Folder.prototype, "contentTypeOrder", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "contentTypeOrder");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "files", {
        get: function () {
            return new files_1.Files(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "folders", {
        get: function () {
            return new Folders(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "listItemAllFields", {
        get: function () {
            return new items_1.Item(this, "listItemAllFields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "parentFolder", {
        get: function () {
            return new Folder(this, "parentFolder");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "properties", {
        get: function () {
            return new queryable_1.QueryableInstance(this, "properties");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "serverRelativeUrl", {
        get: function () {
            return new queryable_1.Queryable(this, "serverRelativeUrl");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Folder.prototype, "uniqueContentTypeOrder", {
        get: function () {
            return new queryable_1.QueryableCollection(this, "uniqueContentTypeOrder");
        },
        enumerable: true,
        configurable: true
    });
    Folder.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return new Folder(this).post({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    Folder.prototype.recycle = function () {
        return new Folder(this, "recycle").post();
    };
    return Folder;
}(queryable_1.QueryableInstance));
exports.Folder = Folder;
